module.exports = __webpack_public_path__ + "static/User-e041d5788a655c2fd102fc01447975f5.png";